export interface Organization {
  organizationId: string;
  name: string;
  ownersNames?: string;
  ownersEmails?: string;
  ownersInfo?: string;
  status?: OrganizationStatus;
  createdAt?: Date;
  lastUpdatedAt?: Date;
  lastProfileUpdate?: Date;
  onboardingDetails?: OnboardingDetails;
  pendings?: any;
  description?: string;
  context?: OrganizationContext;
}

export enum OrganizationStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
}

export interface OnboardingDetails {
  ftueCompleted?: boolean;
  processCreated?: boolean;
  userCreated?: boolean;
  executionRequested?: boolean;
  triggerAdded?: boolean;
  skippedUntil?: string;
}

export interface OrganizationContext {
  mainAreas?: string[];
  troublesomeProcesses?: string[];
}

export interface getOrganizationsRequest {
  getOrganizations: {
    organizations: Organization[];
    count: number;
  };
}

export interface getOrganizationByIdRequest {
  getOrganizationById: Organization;
}

export interface createOrUpdateOrganizationRequest {
  createOrganization?: Organization;
  createOrganizationByEmail?: Organization;
  updateOrganization?: Organization;
}

export interface publicSignupRequest {
  publicSignup: Organization;
}

export interface disableOrEnableOrganizationRequest {
  disableOrganization?: Organization;
  enableOrganization?: Organization;
}

export interface updatePendingActionStatusRequest {
  updatePendingActionStatus: Organization;
}
